import { Paper, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { getUserInputForStepId } from "../../../components/wizard/util";
import { parseAsSelectionAlternative } from "../../../components/data-presentation/util";
import theme from "../../../components/theme/theme";
import { makeStyles, createStyles } from "@mui/styles";
import { baseApiUrl } from "../../../base";
import useWizard from "../../../common/hooks/useWizard";
import DistrictHeatingClimateInfoAngular from "./district-heating-info-angular";

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      padding: "15px",
    },
  })
);

export default function DistrictHeatingClimateInfo() {
  const classes = useStyles(theme);

  const { customer, economicProfile } = useParams();

  let { steps: wizardSteps, wizardIsCompleted } = useWizard(
    customer!,
    economicProfile!
  );
  const district = parseAsSelectionAlternative(
    getUserInputForStepId("DistrictSelected", wizardSteps)?.at(0)?.value
  )?.value;
  const building = parseAsSelectionAlternative(
    getUserInputForStepId("BuildingProfile", wizardSteps)?.at(0)?.value
  )?.value;

  return wizardIsCompleted ? (
    <div>
      <Typography variant="h1">Fjärrvärmesystemet</Typography>
      <Paper className={classes.card} elevation={3} sx={{ mb: 3 }}>
        <Typography paragraph>
          Fjärrvärmen produceras i flera olika anläggningar med olika bränslen.
          Första diagrammet nedan visar hur fjärrvärme produceras på aktuell
          ort.
        </Typography>
        <Typography paragraph>
          Stora baslastanläggningar används först och under större delen av
          året. Mindre spetslastanläggningar används bara när behovet är som
          störst. Om fastigheten ska anslutas till fjärrvärme innebär det att
          vissa anläggningar kommer att producera mer värme jämfört med idag.
          Dessa anläggningar är oftast inte baslastanläggningar som redan idag
          används i hög utsträckning. Istället är det anläggningar som har
          outnyttjad kapacitet. Exakt vilka bränslen som skulle behöva användas
          om fastigheten ansluts till fjärrvärme framgår av andra diagrammet
          nedan.
        </Typography>
      </Paper>
      <DistrictHeatingClimateInfoAngular
        customer={customer}
        district={district}
        building={building}
        economicProfile={economicProfile}
        api={baseApiUrl}
      />
    </div>
  ) : (
    <></>
  );
}
